import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () =>
        import('@/views/PageHome')
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: () =>
        import('@/views/PageUser')
    },
    {
      path: '/others',
      name: 'others',
      component: () =>
        import('@/views/PageOthers')
    },
    {
      path: '/add-slide',
      name: 'add-slide',
      component: () =>
        import('@/views/PageAddSlide')
    },
    {
      path: '/slide/:slideId',
      name: 'slide',
      props: true,
      component: () =>
        import('@/views/PageSlide')
    },
    {
      path: '/edit-profile',
      name: 'edit-profile',
      component: () =>
        import('@/views/PageEditProfile')
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: () =>
        import('@/views/PageTutorial')
    },
    {
      path: '/tutorial/:redirectPath',
      name: 'tutorial',
      props: true,
      component: () =>
        import('@/views/PageTutorial')
    },
    {
      path: '/visualization/:slideId',
      name: 'visualization',
      props: true,
      component: () =>
        import('@/views/PageVisualization')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-in/:redirectPath',
      name: 'sign-in',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    },
    {
      path: '/sign-up/:redirectPath',
      name: 'sign-up',
      props: true,
      component: () =>
        import('@/views/PageSignIn')
    }
  ]
})
